"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManufacturerNames = void 0;
class ManufacturerNames {
    static { this.BUSINESS_TERMS = [
        'inc',
        'incorporated',
        'corp',
        'corporation',
        'ltd',
        'limited',
        'llc',
        'co',
        'company',
        'plc',
        'group',
        'international',
        'intl',
        'global',
        'technologies',
        'technology',
        'tech',
        'industries',
        'industrial',
        'ind',
        'solutions',
        'systems',
        'gmbh',
        'ag',
        'semiconductors',
        'semiconductor',
    ]; }
    static standardize(name) {
        return ManufacturerNames.standardizedWords(name).join('');
    }
    static matchKey(name) {
        const trimmed = name?.trim() ?? '';
        if (trimmed === '') {
            return '';
        }
        const standardized = ManufacturerNames.standardize(trimmed);
        return standardized === '' ? trimmed.toLowerCase() : standardized;
    }
    static areConsistent(first, second) {
        const a = ManufacturerNames.comparableWords(first);
        const b = ManufacturerNames.comparableWords(second);
        if (a.length === 0 || b.length === 0) {
            return false;
        }
        if (a.join('') === b.join('')) {
            return true;
        }
        const [shorter, longer] = a.length <= b.length ? [a, b] : [b, a];
        return shorter.every((word, index) => word === longer[index]);
    }
    static standardizedWords(name) {
        let standardized = name.toLowerCase().trim();
        standardized = standardized.replace(/[.,&]/g, ' ');
        standardized = standardized.replace(/\s+/g, ' ');
        for (const term of ManufacturerNames.BUSINESS_TERMS) {
            const pattern = new RegExp(`\\b${term}\\b`);
            standardized = standardized.replace(pattern, '');
        }
        return standardized.split(/\s+/).filter((word) => word.length > 0);
    }
    static comparableWords(name) {
        return ManufacturerNames.standardizedWords(name)
            .flatMap((word) => word.split(/[-/]/))
            .filter((word) => word.length > 0);
    }
}
exports.ManufacturerNames = ManufacturerNames;
//# sourceMappingURL=manufacturer-names.js.map